import React from "react";
import _ from "lodash";
import {
	Button
} from "react-bootstrap";

import OkButtonContext from "../../contexts/OkButtonContext";

import { getConfigParam } from "../../utils/config";

import state from "../../state";


class DoneButton extends React.PureComponent {

	render() {
		const webMode = getConfigParam("webMode", false);
		if (webMode) {
			return null;
		}

		const { label, visibility, styles } = this.context;
		const content = (label && !_.isEmpty(label)) ? label : state.get(["content"]).items.shared.ok;
		const visible = (visibility && visibility === "hidden") ? false : true;
		const button = visible ? <Button className="player-done-button btn-picker" bsStyle="primary" style={_.assign(styles,{width:"100%"})} disabled={this.props.hasOwnProperty("disabled") ? this.props.disabled : false} onClick={(e) => {
			e.stopPropagation();
			this.props.onSubmit(e);
		}
		}>{content}</Button> : null;

		return <div>{button}</div>;
	}

	
}

DoneButton.contextType = OkButtonContext;

export default DoneButton;